import copy from "copy-to-clipboard"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { WarningIcon } from "@/assets"
import { Button } from "@/ui/Button"
import { Container } from "@/ui/Container"
import "./style.scss"
import { IDefaultError } from "./types"

export const DefaultError: FC<IDefaultError> = ({ error }) => {
  const { t } = useTranslation()

  return (
    <Container
      className="default-error fullscreen"
      triangleTopPosLeft={"20px"}
      triangleBottomPosLeft={"90%"}
    >
      <WarningIcon
        className="default-error__image"
        width="90px"
        height="90px"
      />
      <h1>{t("errorOops")}</h1>
      <h2>{t("errorItSeems")}</h2>
      <Container className="error-info">
        {error.name && (
          <>
            <p>
              <span>Name:</span> {error.name}
            </p>
            <hr />
          </>
        )}
        {error.message && (
          <>
            <p>
              <span>Message:</span> {error.message}
            </p>
            <hr />
          </>
        )}
        {error.stack && (
          <p>
            <span>Details:</span> {error.stack}
          </p>
        )}
      </Container>
      <h3>{t("errorPleaseCopy")}</h3>
      <Button
        onClick={() => {
          copy(
            JSON.stringify({
              name: error.name,
              message: error.message,
              stack: error.stack
            })
          )
        }}
      >
        {t("copy")}
      </Button>
    </Container>
  )
}
